<template>
  <v-app>
    <v-app-bar app :class="[
        $route.name == 'EventsCreate' ? 'barra-branca' : 'barra-rosa',
        'feathered-edges', 
        'bottom',
      ]" 
      style="position: sticky; z-index: 9">
      <v-toolbar-title class="">
        <router-link to="/">
          <v-img
            src="@/assets/mclogoV2.1.svg"
            class="nav-logo"
          ></v-img>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>

    <template>
      <v-app-bar-nav-icon @click="drawer = !drawer" class=" icon-container">
        <v-icon 
            :class="{ 'rotate-in': drawer, 'rotate-out': !drawer }" 
            style="color: black;" 
            id="menu-icon"
            large
          >
          {{ drawer ? 'mdi-close' : 'mdi-menu' }}
        </v-icon>
      </v-app-bar-nav-icon>
    </template>

        
      <div class="app-bar-actions">
        <template >
          <v-btn text class="redirect_button" @click="terms = true;">
            <span>termos e condições</span>
          </v-btn>
        </template>
        <template >
          <v-btn text class="redirect_button" @click="openPolicy">
            <span>política de privacidade</span>
          </v-btn>
        </template>
        <template>
          <v-btn text class="redirect_button" @click="openPro">
            <span>matchcalendars pro</span>
          </v-btn>
        </template>
        <template >
          <v-btn text class="redirect_button" @click="openContacts">
            <span>contacto</span>
          </v-btn>
        </template>
        <v-tooltip bottom v-if="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="logout" text class="redirect_button">
              <span>sair</span>
            </v-btn>
          </template>
          <span>Sair</span>
        </v-tooltip>
      </div>
    </v-app-bar>

  <!-- Drawer para Mobile -->
  <v-navigation-drawer 
      v-model="drawer" 
      app 
      class="d-md-none burger_container" 
      :style="{width: '100%', height: '100vh',  }"
    >
      <v-list>
        <v-list-item @click="openPro">
          <v-list-item-content class="redirect_button">matchcalendars pro</v-list-item-content>
        </v-list-item>

        <v-list-item @click="openContacts">
          <v-list-item-content class="redirect_button">contacto</v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content class="redirect_button" @click="terms = true;">termos e condições</v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content class="redirect_button" @click="openPolicy">política de privacidade</v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
    <v-main style="padding: 0;">

      
      <v-row class="align-center" >
        <v-col cols="12" md="4" class="left-column " >
          
          <div>
            <validation-observer
              ref="login"
              >
              <v-form @submit.prevent="submit" class="mc-form login">
                <h1>iniciar sessão</h1>
                <v-row >
                  <v-col cols="12" lg="9" class="login-field">
                    <validation-provider name="Email\Username" vid="username" rules="required" v-slot="{ errors }">
                      <v-text-field
                        class="entrada-dados"
                        v-model="username"
                        label="email"
                        :error-messages="errors"
                        rows="1"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="9" class="login-field">
                    <validation-provider name="Password" vid="password" rules="required" v-slot="{ errors }">
                      <v-text-field 
                        class="entrada-dados-pass"
                        v-model="password" 
                        type="password" 
                        label="palavra-passe" 
                        :error-messages="errors"
                        rows="1"
                        solo
                        flat
                        hide-details
                      ></v-text-field>

                  </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="9" class="login-field">
                    <v-btn
                      depressed
                      color="black"
                      block
                      dark
                      rounded
                      large
                      type="submit"
                      style="text-transform: none !important;"
                      class="login-btn"
                    >
                      entrar
                    </v-btn>
                  </v-col>
                  <v-col cols="12" lg="9" class="login-field">
                    <!-- Container do botão -->
                    <div class="google-login-container">
                      <!-- Botão personalizado -->
                      <v-btn
                        depressed
                        color="black"
                        block
                        dark
                        rounded
                        outlined
                        large
                        style="font-weight: bold; text-transform: none;"
                      >
                        <img src="@/assets/logo/logo_google_g_icon.svg" class="google-icon">
                        Continuar com Google
                      </v-btn>


                      <!-- Botão real da Google (sobreposto e invisível) -->
                      <div id="hidden-google-btn"></div>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="9" class="login-field text-center text-md-left text-infos">
                    <label>Ainda não tem conta? Registe-se <router-link to="/register">aqui</router-link></label>
                  </v-col>
                  <v-col cols="12" lg="9" class=" login-field text-center text-md-left text-infos">
                    <label class="text-decoration-underline" style="cursor: pointer;" @click="reset_password.opened = !reset_password.opened">Esqueci-me da password</label>
                  </v-col>                 
                </v-row>
              </v-form>
            </validation-observer>
          </div>          
        </v-col>

        <!-- Coluna da direita com a imagem -->
        <v-col cols="12" md="4" class="right-column">
          <v-img
            src="@/assets/papelEventos1.png"
            alt="Imagem de Login"
            max-width="100%"
            height="auto"
            contain
            class="img_size"
          />
        </v-col>

      </v-row>
      
    </v-main>
    <v-footer style="background-color: #E9CFED !important; " app>
      <span class="body-2 my-2" style="margin: auto; display: block;">Powered By <a target="_blank" href="https://www.dreamdealtech.pt/">Dreamdeal Technologies</a></span>
    </v-footer>

    <v-dialog v-model="registerDialog" max-width="500px">
      <v-card>
        <v-card-title class="background-image">
          <span class="headline" v-if="!registrationComplete">Registar</span>
          <span class="headline" v-else>Registro Completo</span>
        </v-card-title>
        <v-card-text>
          <v-form v-if="!registrationComplete">

            <validation-provider name="Nome" vid="name" rules="required" v-slot="{ errors }">
            <v-text-field
            class="mt-8"
              v-model="name"
              label="Nome"
              prepend-icon="mdi-account"
              outlined
              :error-messages="errors"

            ></v-text-field>
          </validation-provider>

            <validation-provider name="Email" vid="email" rules="required|email" v-slot="{ errors }">
            <v-text-field
              v-model="email"
              label="Email"
              prepend-icon="mdi-email"
              outlined
              :error-messages="errors"
            ></v-text-field>
          </validation-provider>
          </v-form>
          <div v-else>
            <p>Para concluir o registo siga os passos do email que lhe foi enviado.</p>
          </div>
        </v-card-text>
        <v-card-actions v-if="!registrationComplete">
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="registerDialog = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-btn color="green darken-1" icon @click="register"><v-icon>mdi-check</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog
        v-model="reset_password.opened"
        max-width="600px"
      >
        <v-card>
          <v-card-title class="background-image d-flex justify-space-between align-center" style="font-size: 15px;">
            <span class="h5">Reset Password</span>
            <v-btn icon color="red" @click="reset_password.opened = false" class="d-none d-md-flex">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <validation-observer v-if="!reset_password.reseted" ref="reset" v-slot="{ invalid }">
              <v-form @submit.prevent="reset">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <validation-provider v-slot="{ errors }" vid="email" name="Email" rules="required|email">
                        <v-text-field
                          v-model="reset_password.email"
                          dense outlined
                          prepend-inner-icon="mdi-at"
                          label="Email"
                          class="entrada-dados reset-email"
                          type="email"
                          clearable
                          :error-messages="errors"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row class="mt-6 d-none d-md-flex" align="center" justify="space-around">
                    <v-col align="center" justify="space-around">
                      <v-btn :disabled="invalid" depressed color="primary" class="mr-5 ml-5" type="submit" style="text-transform: capitalize !important;">
                        Enviar email
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </validation-observer>
            <v-container v-else>
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                    offset-md="3"
                  >
                  <h2 class="success--text text-center">Email enviado!</h2>
                  <v-row class="mt-6" align="center" justify="space-around">
                    <v-icon
                      large
                      class="text-center"
                      color="success"
                    >
                      mdi-checkbox-marked-circle-outline
                    </v-icon>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="d-flex d-md-none justify-center pt-2 pb-4">
            <v-row>
              <v-col cols="12" align="center" justify="center">
                <v-btn depressed color="primary" type="submit" block>
                  Enviar email
                </v-btn>
              </v-col>
              <v-col cols="12" align="center" justify="center">
                <v-btn color="error" @click="reset_password.opened = false" block>
                  Fechar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-if="showMaintenance"
          v-model="showMaintenance"
          max-width="350px"
        >
          <v-container fluid class="ma-0 pa-0">
            <v-card class="elevation-0 ma-0 pa-0">
              <v-card-title class="primary white--text">
                Site em Manutenção
              </v-card-title>
              <v-card-text class="mt-2 text-center">
                O seu login não será bem sucedido enquanto o site estiver em manutenção. Agradecemos a sua compreensão!
              </v-card-texT>
              <v-card-text class="justify-center">
                <v-avatar height="105" width="300" tile style="margin: auto; display: block;">
                <v-img
                    src="@/assets/Maintenance/manutencao.png"
                    lazy-src="@/assets/Maintenance/manutencao.png"
                    contain
                >
                  </v-img>
                </v-avatar>
              </v-card-text>
              <v-card-text class="text-center">
                Tentaremos ser o mais breves possível!
              </v-card-text>
            </v-card>
          </v-container>
        </v-dialog>

        <CreateGoogleAccountModal
          v-model="createGoogleAccount"
          :googleUser="googleUser"
          @register="registerGoogleLogin"
        />

        
        <ErrorSnackbar v-model="error.show" :message="error.message"/>

        <Politica @close="policy = false;" v-if="policy" />

        <Termos @privacy-open="policy = true" @close="terms = false;" v-if="terms" />

        <ContactoModal @close="contacto = false;" v-if="contacto" />

        <ProModal @close="pro = false;" v-if="pro" />
  </v-app>
</template>

<script>
import User from "@/api/User.js"
//import System from "@/api/System.js"
import { msalMixin } from 'vue-msal';
import {jwtDecode} from "jwt-decode";
import CreateGoogleAccountModal from '@/components/dialogs/CreateGoogleAccount.vue'
import ErrorSnackbar from '@/components/ui/ErrorSnackbar.vue';
import Politica from '@/views/PoliticaPrivacidade.vue'
import Termos from '@/views/TermosCondicoes.vue'
import ContactoModal from "./ContactoModal.vue"
import ProModal from "./ProModal.vue"

export default {
  components: {
    CreateGoogleAccountModal,
    ErrorSnackbar,
    Politica,
    Termos,
    ContactoModal,
    ProModal,
  },
  mixins: [msalMixin],
  watch:{
    createGoogleAccount:{
      handler (newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          window.location.reload();
        }
      }
    }
  },
  data: () => ({
    reloadModalGoogle: 0,
    createGoogleAccount: false,
    drawer: false,
    username: "",
    password: "",
    policy: false,
    terms: false,
    contacto: false,
    pro: false,
    error:{
      show: false,
      message: null
    },
    googleUser: null,
    reset_password: {
      opened: false,
      email: "",
      reseted: false,
 
    },
    showMaintenance: false,
    registerDialog: false,
      registrationComplete: false,
      name: '',
      email: '',
  }),
  beforeCreate(){
    document.title = "MatchCalendar - Login";

    if(localStorage['auth'] == 1){
      this.$router.push('');
    }
  },
  mounted(){
    console.log('Preparing application log')
    if (!window.google) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      script.onload = this.setupGoogleLogin;
      document.head.appendChild(script);
    } else {
      this.setupGoogleLogin();
    }
    const redirectedLogin = sessionStorage.getItem("redirectedLogin");
    if (redirectedLogin) {
      this.error.show = true;
      this.error.message = redirectedLogin;
      sessionStorage.removeItem("redirectedLogin");
    }


    let cookieLogin = this.$cookies.get('login-try');
    let cookie = this.$cookies.get('reportlake_portal_cookie');

    if(cookie == null)
        this.showCookieBar = true

    if(cookieLogin){
      if(this.$msal.isAuthenticated()){
        User.microsoftLogin(this.$msal.data.user.userName, this.$msal.data.user.idToken.oid)
            .then(({data}) => {

                if(data.two_factor){
                  this.$router.push('/2fa');

                  return;
                }

                localStorage['auth'] = 1;

                this.$cookies.remove('login-try');

                this.$router.push('');
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.login.setErrors(err.response.data.errors);

                return;
              }
          });
        }
    }
  },

  methods:{
    openPolicy(){
      this.policy = true;
    },

    openContacts(){
      this.contacto = true;
    },

    openPro(){
      this.pro = true;
    },

    setupGoogleLogin() {
      this.$nextTick(() => {
        const el = document.getElementById("hidden-google-btn");
        const w = Math.round(el.getBoundingClientRect().width || 320);

        window.google.accounts.id.initialize({
          client_id: this.getAPIKEY,
          callback: this.handleCredentialResponse,
        });

        window.google.accounts.id.renderButton(el, {
          theme: "outline",
          size: "large",
          shape: "pill",
          text: "continue_with",
          width: w, // ✅ número (px)
        });
      });
    },
    async registerGoogleLogin() {
      this.createGoogleAccount = false;

      const redirectPath = localStorage.getItem('redirectPath') || '/';
      localStorage.removeItem('redirectPath');

      this.$router.push(redirectPath).catch(err => {
          console.error("Erro ao redirecionar:", err);
        }).finally(() => {
          localStorage.removeItem('redirectPath');
        });
    },
    async handleCredentialResponse(response) {
      const idToken = response.credential;
      const userData = jwtDecode(idToken);

      const data = {
        email: userData.email,
        token: idToken,
        name: userData.name,
      };

      this.googleUser = data;

      try {
        // Remove a sessão Laravel anterior.
        try {
          await User.logout(
            this.$root.session !== undefined
              ? this.$root.session.id
              : null
          );
        } catch (logoutError) {
          // Mesmo que já não exista sessão, continua com o login.
          console.log("Não existia sessão para terminar.");
        }

        await User.googleLogin(data);

        localStorage.setItem("auth", "1");

        const redirectPath =
          localStorage.getItem("redirectPath") || "/";

        localStorage.removeItem("redirectPath");

        await this.$router.push(redirectPath).catch((err) => {
          if (err && err.name !== "NavigationDuplicated") {
            console.error("Erro ao redirecionar:", err);
          }
        });
      } catch (err) {
        console.log(
          "googleLogin status",
          err.response && err.response.status
        );

        if (err.response && err.response.status === 403) {
          this.error.message =
            err.response.data.message ||
            "Não foi possível iniciar sessão com a Google.";

          this.error.show = true;
          return;
        }

        if (err.response && err.response.status === 422) {
          this.createGoogleAccount = true;
          return;
        }

        this.error.message =
          "Não foi possível iniciar sessão com a Google.";

        this.error.show = true;
      }
    },
    openRegisterDialog() {
      this.registerDialog = true;
    },

    async register() {
      try {
        let response = {
          name: this.name,
          email: this.email
        }
        await User.create(response);
        this.registrationComplete = true;
      } catch (error) {
        console.error('Erro ao registrar:', error);
      }
    },

    async microsoftLogin(){
      this.$cookies.set('login-try', true);

      if(this.$msal.isAuthenticated()){
        User.logout(this.$root.session != undefined ? this.$root.session.id : null)
            .then(() => {
            }).catch(() => {
            })
        User.microsoftLogin(this.$msal.data.user.userName, this.$msal.data.user.idToken.oid)
            .then(({data}) => {

              if(data.two_factor){
                this.$router.push('/2fa');

                return;
              }

              localStorage['auth'] = 1;

              this.$cookies.remove('login-try');


              this.$router.push('');
            }).catch(err => {

              if(err.response.status == 422) {

                this.$refs.login.setErrors(err.response.data.errors);

                return;
              }
          });
        }else{
          this.$msal.signIn()
        }
    },
    submit () {
        this.$refs.login.validate().then((valid) => {
          if (!valid) {
            return;
          }

          User.logout()
            .then(() => {
              this.login();
            }).catch(() => {
              this.login();
            })
        });

 
      },

      login(){
        let pwd = this.$encryptValue(this.password);

        User.login(this.username, pwd)
          .then(({data}) => {

            
              if(data.two_factor){
                this.$router.push('/2fa');

                return;
              }
                

              localStorage.setItem('auth', '1');

            // Obter a rota para redirecionar após o login ou redirecionar para a página padrão '/'
            const redirectPath = localStorage.getItem('redirectPath') || '/';

            // Redirecionar para a página de destino
            this.$router.push(redirectPath).catch(err => console.error("Erro ao redirecionar:", err));

            // Limpar o valor de 'redirectTo' após o login
            localStorage.removeItem('redirectPath');

          }).catch(err => {
            if(err.response.status == 404){
              localStorage.setItem('email_to_confirm', this.username);
              this.$router.push('/register');
              return;
            }

            this.error.message = "O seu email/password estão incorretos!"
            this.error.show = true

            if(err.response.status == 422) {

              this.$refs.login.setErrors(err.response.data.errors);

              return;
            }

        });
      },
      
      reset () {
        this.$refs.reset.validate().then((valid) => {
          if (!valid) {
            return;
          }

          console.log(this.reset_password.email);
          console.log("Aqui");
          console.dir(User);

          User.reset(this.reset_password.email)
            
            .then(() => {

                this.reset_password.reseted = true;
            }).catch(err => {

              console.log(this.reset_password.email);
          console.log("Aqui");
          console.dir(User);

              if(err.response.status == 422) {

                this.$refs.reset.setErrors(err.response.data.errors);

                return;
              }

              this.reset_password.reseted = false;

          });
        });
      },
  },

  computed:{
    getAPIKEY(){
      return process.env.VUE_APP_GOOGLE_API
    },
    user() {
        let user = null;
        if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
          user = {
            ...this.msal.user,
            profile: {}
          }
          if (this.msal.graph && this.msal.graph.profile) {
              user.profile = this.msal.graph.profile
          }
        }

        return user;
      }
  }
};
</script>


<style scoped>

.barra-rosa {
  background-color: #E9CFED !important;
}

.theme--light.v-btn.v-btn--icon.icon-container[data-v-64778763]  {
  color: rgba(0, 0, 0, 0); 
}

.v-btn:before {
  background-color: transparent !important;
}

.burger_container {
  background-color: #E9CFED !important;
}

.login-btn{
  background-color: #111b2d !important;
  color: #E9CFED !important;
  border-radius: 30px !important;
  box-shadow: none !important;
  width:100%;
  font-size: 14px;
  font-weight: 700;
}

.v-text-field.v-text-field--solo .v-label, .v-select__selection {
  text-align: center;
  margin-left: 31px !important;
  font-weight: 300;
  font-size: 15px;
}

.entrada-dados .v-input__control{
  border-radius: 30px !important;
  box-shadow: none !important;
  width: 100% !important;
}

.entrada-dados-pass .v-input__control{
  border-radius: 30px !important;
  box-shadow: none !important;
  width: 100% !important;
}

.entrada-dados .v-input.v-input--is-solo {
  background: rgba(255, 255, 255, 0,5) !important;
  border-radius: 30px !important;
}

.entrada-dados-pass .v-input.v-input--is-solo {
  background: rgba(255, 255, 255, 0,5) !important;
  border-radius: 30px !important;
}

.form-content {
  max-width: 400px; /* Define largura máxima dos elementos */
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px; /* Espaçamento uniforme entre os elementos */
}

.event-image {
  max-width: 80%;
  height: auto;
  padding: 40px;
  
}

.fixed-image {
  position: fixed;
  top: 0;
  right: 0;
  margin-right: 100px;
  height: 100dvh;
  width: auto;
}

.login-google-btn{
  background-color: #921111 !important;
  color: white !important;
  border-radius: 30px !important;
  box-shadow: none !important;
  font-weight: bold !important;
  width: 100%;
  max-width: 400px;
}

.login-google-btn >>> .v-btn {
  background-color: #971e1e !important;
  color: #000000 !important;
  border-radius: 50px !important;
  box-shadow: none !important;
  font-weight: bold !important;
}

.google-login-container {
  position: relative;
  width: 100%;
  max-width: 8000px; /* Ajusta ao tamanho do botão */
}

#hidden-google-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0; /* Invisível, mas clicável */
  cursor: pointer;
  z-index: 10; /* Mantém sobreposto ao botão fake */
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}

.logo-img {
  margin-bottom: 70px;
  max-width: 250px;
  height: auto;
  width: auto;
}

.text-white label {
  color: white !important;
}
.text-white i {
  color: white !important;
}
.text-white v-messages__wrapper{
  color: white !important;
}
.rose-color{
  background-color: #E9CFED !important;    
}

.footer-content {
  position: fixed;
  bottom: 10px; /* Distância do fundo da página */
  left: 50%;
  transform: translateX(-50%); /* Alinha o conteúdo ao centro horizontalmente */
  text-align: center;
  color: white;
  width: 100%;
  z-index:1000
}

.text-decoration-underline{
  margin-bottom: 2cm;
}

.google-icon {
  margin-right: 10px;
  width: 25px;
  height: 25px;
}

@media (max-width: 960px) {

  .logo-img {
    margin-bottom: 0;
    max-width: 100%;
    height: auto;
    width: auto;
  }

  .entrada-dados {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
  .entrada-dados-pass {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .form-content {
    max-width: 100%;
  }

  .entrada-dados .v-input__control {
    font-size: 14px !important;
  }

  .entrada-dados-pass .v-input__control {
    font-size: 14px !important;
  }

  .login-btn {
    width: 100% !important; 
    height: 48px !important; 
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login-google-btn {
    width: 100% !important;
  }

  .center-button {
    font-size: 14px !important;
    padding: 10px !important;
    margin-right: 15px !important;
  }

  .text-infos {
    font-size: 12px;
    font-weight: 500;
  }
}

/* Só a caixa de Email da modal */
.reset-email { width: 100%; max-width: 100%; }

/* manter o “pill” arredondado */
.reset-email :deep(.v-input__slot) {
  border-radius: 30px !important;
  background: rgba(255, 255, 255, 0.5);
}

/* garantir que não herda min-width do login em ecrãs pequenos */
@media (max-width: 960px) {
  .reset-email { min-width: 0 !important; }
}

/* (opcional) se vires o label/deslocado, neutraliza aqui só para este campo */
.reset-email :deep(.v-label) {
  margin-left: 0 !important;
  text-align: left;
}

/* Chrome / Edge / Opera / Safari */
html body input:-webkit-autofill,
html body input:-webkit-autofill:hover,
html body input:-webkit-autofill:focus {
  /* mata o azul do UA */
  -webkit-appearance: none !important;
  appearance: none !important;

  background-color: #ffffff !important;
  background-image: none !important;

  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  box-shadow:        0 0 0 1000px #ffffff inset !important;

  -webkit-text-fill-color: #000 !important;
}

/* Firefox (não usa o azul, mas por precaução) */
html body input:-moz-autofill {
  box-shadow: 0 0 0 1000px #ffffff inset !important;
  -moz-text-fill-color: #000 !important;
}

.google-login-container .v-btn {
  pointer-events: none; /* ✅ cliques passam sempre para a camada da Google */
}

#hidden-google-btn {
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 10;
}

#hidden-google-btn > div,
#hidden-google-btn iframe {
  width: 100% !important;
  height: 100% !important;
}



</style>